// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v7.35.1
// source: strategy.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { Security } from "./candle-data-depot-common";
import { Empty } from "./google/protobuf/empty";
import { TransactionType, transactionTypeFromJSON, transactionTypeToJSON } from "./order";
import {
  OptionType,
  optionTypeFromJSON,
  optionTypeToJSON,
  SecurityCategory_CategoryCode,
  securityCategory_CategoryCodeFromJSON,
  securityCategory_CategoryCodeToJSON,
} from "./security";
import Long from "long";

export const protobufPackage = "com.tick2trade.api.strategy";

export interface StrategyTemplateProto {
  id: string;
  name: string;
  strategyTemplateLegs: StrategyTemplateLegsProto | undefined;
  group: StrategyTemplateProto_StrategyTemplateGroup;
  description?: string | undefined;
  imageUrl?: string | undefined;
  security?: Security | undefined;
}

export enum StrategyTemplateProto_StrategyTemplateGroup {
  STRATEGY_TEMPLATE_GROUP_UNKNOWN = 0,
  BEARISH = 1,
  BULLISH = 2,
  NEUTRAL = 3,
  CUSTOM = 4,
  UNRECOGNIZED = -1,
}

export function strategyTemplateProto_StrategyTemplateGroupFromJSON(
  object: any,
): StrategyTemplateProto_StrategyTemplateGroup {
  switch (object) {
    case 0:
    case "STRATEGY_TEMPLATE_GROUP_UNKNOWN":
      return StrategyTemplateProto_StrategyTemplateGroup.STRATEGY_TEMPLATE_GROUP_UNKNOWN;
    case 1:
    case "BEARISH":
      return StrategyTemplateProto_StrategyTemplateGroup.BEARISH;
    case 2:
    case "BULLISH":
      return StrategyTemplateProto_StrategyTemplateGroup.BULLISH;
    case 3:
    case "NEUTRAL":
      return StrategyTemplateProto_StrategyTemplateGroup.NEUTRAL;
    case 4:
    case "CUSTOM":
      return StrategyTemplateProto_StrategyTemplateGroup.CUSTOM;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StrategyTemplateProto_StrategyTemplateGroup.UNRECOGNIZED;
  }
}

export function strategyTemplateProto_StrategyTemplateGroupToJSON(
  object: StrategyTemplateProto_StrategyTemplateGroup,
): string {
  switch (object) {
    case StrategyTemplateProto_StrategyTemplateGroup.STRATEGY_TEMPLATE_GROUP_UNKNOWN:
      return "STRATEGY_TEMPLATE_GROUP_UNKNOWN";
    case StrategyTemplateProto_StrategyTemplateGroup.BEARISH:
      return "BEARISH";
    case StrategyTemplateProto_StrategyTemplateGroup.BULLISH:
      return "BULLISH";
    case StrategyTemplateProto_StrategyTemplateGroup.NEUTRAL:
      return "NEUTRAL";
    case StrategyTemplateProto_StrategyTemplateGroup.CUSTOM:
      return "CUSTOM";
    case StrategyTemplateProto_StrategyTemplateGroup.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface StrategyTemplatesProto {
  strategyTemplates: StrategyTemplateProto[];
}

export interface EvaluatedStrategy {
  strategyLegs: EvaluatedStrategy_StrategyLeg[];
}

export enum EvaluatedStrategy_BuySellIndicator {
  BUY = 0,
  SELL = 1,
  UNRECOGNIZED = -1,
}

export function evaluatedStrategy_BuySellIndicatorFromJSON(object: any): EvaluatedStrategy_BuySellIndicator {
  switch (object) {
    case 0:
    case "BUY":
      return EvaluatedStrategy_BuySellIndicator.BUY;
    case 1:
    case "SELL":
      return EvaluatedStrategy_BuySellIndicator.SELL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EvaluatedStrategy_BuySellIndicator.UNRECOGNIZED;
  }
}

export function evaluatedStrategy_BuySellIndicatorToJSON(object: EvaluatedStrategy_BuySellIndicator): string {
  switch (object) {
    case EvaluatedStrategy_BuySellIndicator.BUY:
      return "BUY";
    case EvaluatedStrategy_BuySellIndicator.SELL:
      return "SELL";
    case EvaluatedStrategy_BuySellIndicator.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface EvaluatedStrategy_StrategyLeg {
  security: Security | undefined;
  buySellIndicator: EvaluatedStrategy_BuySellIndicator;
  quantity: number;
}

export interface StrategyTemplateLegProto {
  id: string;
  categoryCode: SecurityCategory_CategoryCode;
  expirySelection: StrategyTemplateLegProto_ExpirySelectionProto | undefined;
  transactionType: TransactionType;
  lots: number;
  optionType?: OptionType | undefined;
  strikeCriteria?: StrategyTemplateLegProto_StrikeCriteriaProto | undefined;
}

export interface StrategyTemplateLegProto_ExpirySelectionProto {
  expirySelectionType: StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType;
  minimumDaysToExpiry?: number | undefined;
  rolloverFlag?: boolean | undefined;
}

export enum StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType {
  EXPIRY_SELECTION_TYPE_UNKNOWN = 0,
  WEEKLY = 1,
  NEXT_WEEKLY = 2,
  MONTHLY = 3,
  NEXT_MONTHLY = 4,
  MINIMUM_DAYS_TO_MONTHLY_EXPIRY = 5,
  UNRECOGNIZED = -1,
}

export function strategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionTypeFromJSON(
  object: any,
): StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType {
  switch (object) {
    case 0:
    case "EXPIRY_SELECTION_TYPE_UNKNOWN":
      return StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.EXPIRY_SELECTION_TYPE_UNKNOWN;
    case 1:
    case "WEEKLY":
      return StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.WEEKLY;
    case 2:
    case "NEXT_WEEKLY":
      return StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.NEXT_WEEKLY;
    case 3:
    case "MONTHLY":
      return StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.MONTHLY;
    case 4:
    case "NEXT_MONTHLY":
      return StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.NEXT_MONTHLY;
    case 5:
    case "MINIMUM_DAYS_TO_MONTHLY_EXPIRY":
      return StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.MINIMUM_DAYS_TO_MONTHLY_EXPIRY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.UNRECOGNIZED;
  }
}

export function strategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionTypeToJSON(
  object: StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType,
): string {
  switch (object) {
    case StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.EXPIRY_SELECTION_TYPE_UNKNOWN:
      return "EXPIRY_SELECTION_TYPE_UNKNOWN";
    case StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.WEEKLY:
      return "WEEKLY";
    case StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.NEXT_WEEKLY:
      return "NEXT_WEEKLY";
    case StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.MONTHLY:
      return "MONTHLY";
    case StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.NEXT_MONTHLY:
      return "NEXT_MONTHLY";
    case StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.MINIMUM_DAYS_TO_MONTHLY_EXPIRY:
      return "MINIMUM_DAYS_TO_MONTHLY_EXPIRY";
    case StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface StrategyTemplateLegProto_StrikeCriteriaProto {
  strikeType: StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType;
  referenceType: StrategyTemplateLegProto_StrikeCriteriaProto_ReferenceType;
  value: number;
  parametersMap: { [key: string]: number };
}

export enum StrategyTemplateLegProto_StrikeCriteriaProto_ReferenceType {
  REFERENCE_TYPE_UNKNOWN = 0,
  SPOT = 1,
  FUTURE = 2,
  SYNTHETIC_FUTURE = 3,
  UNRECOGNIZED = -1,
}

export function strategyTemplateLegProto_StrikeCriteriaProto_ReferenceTypeFromJSON(
  object: any,
): StrategyTemplateLegProto_StrikeCriteriaProto_ReferenceType {
  switch (object) {
    case 0:
    case "REFERENCE_TYPE_UNKNOWN":
      return StrategyTemplateLegProto_StrikeCriteriaProto_ReferenceType.REFERENCE_TYPE_UNKNOWN;
    case 1:
    case "SPOT":
      return StrategyTemplateLegProto_StrikeCriteriaProto_ReferenceType.SPOT;
    case 2:
    case "FUTURE":
      return StrategyTemplateLegProto_StrikeCriteriaProto_ReferenceType.FUTURE;
    case 3:
    case "SYNTHETIC_FUTURE":
      return StrategyTemplateLegProto_StrikeCriteriaProto_ReferenceType.SYNTHETIC_FUTURE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StrategyTemplateLegProto_StrikeCriteriaProto_ReferenceType.UNRECOGNIZED;
  }
}

export function strategyTemplateLegProto_StrikeCriteriaProto_ReferenceTypeToJSON(
  object: StrategyTemplateLegProto_StrikeCriteriaProto_ReferenceType,
): string {
  switch (object) {
    case StrategyTemplateLegProto_StrikeCriteriaProto_ReferenceType.REFERENCE_TYPE_UNKNOWN:
      return "REFERENCE_TYPE_UNKNOWN";
    case StrategyTemplateLegProto_StrikeCriteriaProto_ReferenceType.SPOT:
      return "SPOT";
    case StrategyTemplateLegProto_StrikeCriteriaProto_ReferenceType.FUTURE:
      return "FUTURE";
    case StrategyTemplateLegProto_StrikeCriteriaProto_ReferenceType.SYNTHETIC_FUTURE:
      return "SYNTHETIC_FUTURE";
    case StrategyTemplateLegProto_StrikeCriteriaProto_ReferenceType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType {
  STRIKE_TYPE_UNKNOWN = 0,
  ATM_POINT = 1,
  ATM_PERCENTAGE = 2,
  STRADDLE_WIDTH = 3,
  CLOSEST_PREMIUM = 4,
  CLOSEST_DELTA = 5,
  CP_ON_STRADDLE_PREMIUM = 6,
  STANDARD_DEVIATION = 7,
  SAME_AS_PREVIOUS_LEG = 8,
  UNRECOGNIZED = -1,
}

export function strategyTemplateLegProto_StrikeCriteriaProto_StrikeTypeFromJSON(
  object: any,
): StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType {
  switch (object) {
    case 0:
    case "STRIKE_TYPE_UNKNOWN":
      return StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.STRIKE_TYPE_UNKNOWN;
    case 1:
    case "ATM_POINT":
      return StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.ATM_POINT;
    case 2:
    case "ATM_PERCENTAGE":
      return StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.ATM_PERCENTAGE;
    case 3:
    case "STRADDLE_WIDTH":
      return StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.STRADDLE_WIDTH;
    case 4:
    case "CLOSEST_PREMIUM":
      return StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.CLOSEST_PREMIUM;
    case 5:
    case "CLOSEST_DELTA":
      return StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.CLOSEST_DELTA;
    case 6:
    case "CP_ON_STRADDLE_PREMIUM":
      return StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.CP_ON_STRADDLE_PREMIUM;
    case 7:
    case "STANDARD_DEVIATION":
      return StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.STANDARD_DEVIATION;
    case 8:
    case "SAME_AS_PREVIOUS_LEG":
      return StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.SAME_AS_PREVIOUS_LEG;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.UNRECOGNIZED;
  }
}

export function strategyTemplateLegProto_StrikeCriteriaProto_StrikeTypeToJSON(
  object: StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType,
): string {
  switch (object) {
    case StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.STRIKE_TYPE_UNKNOWN:
      return "STRIKE_TYPE_UNKNOWN";
    case StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.ATM_POINT:
      return "ATM_POINT";
    case StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.ATM_PERCENTAGE:
      return "ATM_PERCENTAGE";
    case StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.STRADDLE_WIDTH:
      return "STRADDLE_WIDTH";
    case StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.CLOSEST_PREMIUM:
      return "CLOSEST_PREMIUM";
    case StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.CLOSEST_DELTA:
      return "CLOSEST_DELTA";
    case StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.CP_ON_STRADDLE_PREMIUM:
      return "CP_ON_STRADDLE_PREMIUM";
    case StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.STANDARD_DEVIATION:
      return "STANDARD_DEVIATION";
    case StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.SAME_AS_PREVIOUS_LEG:
      return "SAME_AS_PREVIOUS_LEG";
    case StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface StrategyTemplateLegProto_StrikeCriteriaProto_ParametersMapEntry {
  key: string;
  value: number;
}

export interface StrategyTemplateLegsProto {
  strategyTemplateLegs: StrategyTemplateLegProto[];
}

export interface OptionPosition {
  optionType: OptionType;
  transactionType: TransactionType;
  strikePrice: number;
  expiry: number;
  lots: number;
}

export interface OptionPositionRequest {
  optionPosition: OptionPosition[];
}

export interface OptionPositionResponse {
  strategyName: string;
}

function createBaseStrategyTemplateProto(): StrategyTemplateProto {
  return {
    id: "",
    name: "",
    strategyTemplateLegs: undefined,
    group: 0,
    description: undefined,
    imageUrl: undefined,
    security: undefined,
  };
}

export const StrategyTemplateProto = {
  encode(message: StrategyTemplateProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.strategyTemplateLegs !== undefined) {
      StrategyTemplateLegsProto.encode(message.strategyTemplateLegs, writer.uint32(26).fork()).ldelim();
    }
    if (message.group !== 0) {
      writer.uint32(32).int32(message.group);
    }
    if (message.description !== undefined) {
      writer.uint32(42).string(message.description);
    }
    if (message.imageUrl !== undefined) {
      writer.uint32(50).string(message.imageUrl);
    }
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(58).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StrategyTemplateProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStrategyTemplateProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.strategyTemplateLegs = StrategyTemplateLegsProto.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.group = reader.int32() as any;
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.description = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.imageUrl = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StrategyTemplateProto {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      strategyTemplateLegs: isSet(object.strategyTemplateLegs)
        ? StrategyTemplateLegsProto.fromJSON(object.strategyTemplateLegs)
        : undefined,
      group: isSet(object.group) ? strategyTemplateProto_StrategyTemplateGroupFromJSON(object.group) : 0,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      imageUrl: isSet(object.imageUrl) ? globalThis.String(object.imageUrl) : undefined,
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
    };
  },

  toJSON(message: StrategyTemplateProto): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.strategyTemplateLegs !== undefined) {
      obj.strategyTemplateLegs = StrategyTemplateLegsProto.toJSON(message.strategyTemplateLegs);
    }
    if (message.group !== 0) {
      obj.group = strategyTemplateProto_StrategyTemplateGroupToJSON(message.group);
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.imageUrl !== undefined) {
      obj.imageUrl = message.imageUrl;
    }
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StrategyTemplateProto>, I>>(base?: I): StrategyTemplateProto {
    return StrategyTemplateProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StrategyTemplateProto>, I>>(object: I): StrategyTemplateProto {
    const message = createBaseStrategyTemplateProto();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.strategyTemplateLegs = (object.strategyTemplateLegs !== undefined && object.strategyTemplateLegs !== null)
      ? StrategyTemplateLegsProto.fromPartial(object.strategyTemplateLegs)
      : undefined;
    message.group = object.group ?? 0;
    message.description = object.description ?? undefined;
    message.imageUrl = object.imageUrl ?? undefined;
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    return message;
  },
};

function createBaseStrategyTemplatesProto(): StrategyTemplatesProto {
  return { strategyTemplates: [] };
}

export const StrategyTemplatesProto = {
  encode(message: StrategyTemplatesProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.strategyTemplates) {
      StrategyTemplateProto.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StrategyTemplatesProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStrategyTemplatesProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.strategyTemplates.push(StrategyTemplateProto.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StrategyTemplatesProto {
    return {
      strategyTemplates: globalThis.Array.isArray(object?.strategyTemplates)
        ? object.strategyTemplates.map((e: any) => StrategyTemplateProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: StrategyTemplatesProto): unknown {
    const obj: any = {};
    if (message.strategyTemplates?.length) {
      obj.strategyTemplates = message.strategyTemplates.map((e) => StrategyTemplateProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StrategyTemplatesProto>, I>>(base?: I): StrategyTemplatesProto {
    return StrategyTemplatesProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StrategyTemplatesProto>, I>>(object: I): StrategyTemplatesProto {
    const message = createBaseStrategyTemplatesProto();
    message.strategyTemplates = object.strategyTemplates?.map((e) => StrategyTemplateProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseEvaluatedStrategy(): EvaluatedStrategy {
  return { strategyLegs: [] };
}

export const EvaluatedStrategy = {
  encode(message: EvaluatedStrategy, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.strategyLegs) {
      EvaluatedStrategy_StrategyLeg.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EvaluatedStrategy {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEvaluatedStrategy();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.strategyLegs.push(EvaluatedStrategy_StrategyLeg.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EvaluatedStrategy {
    return {
      strategyLegs: globalThis.Array.isArray(object?.strategyLegs)
        ? object.strategyLegs.map((e: any) => EvaluatedStrategy_StrategyLeg.fromJSON(e))
        : [],
    };
  },

  toJSON(message: EvaluatedStrategy): unknown {
    const obj: any = {};
    if (message.strategyLegs?.length) {
      obj.strategyLegs = message.strategyLegs.map((e) => EvaluatedStrategy_StrategyLeg.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EvaluatedStrategy>, I>>(base?: I): EvaluatedStrategy {
    return EvaluatedStrategy.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EvaluatedStrategy>, I>>(object: I): EvaluatedStrategy {
    const message = createBaseEvaluatedStrategy();
    message.strategyLegs = object.strategyLegs?.map((e) => EvaluatedStrategy_StrategyLeg.fromPartial(e)) || [];
    return message;
  },
};

function createBaseEvaluatedStrategy_StrategyLeg(): EvaluatedStrategy_StrategyLeg {
  return { security: undefined, buySellIndicator: 0, quantity: 0 };
}

export const EvaluatedStrategy_StrategyLeg = {
  encode(message: EvaluatedStrategy_StrategyLeg, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    if (message.buySellIndicator !== 0) {
      writer.uint32(16).int32(message.buySellIndicator);
    }
    if (message.quantity !== 0) {
      writer.uint32(24).int32(message.quantity);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EvaluatedStrategy_StrategyLeg {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEvaluatedStrategy_StrategyLeg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.buySellIndicator = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.quantity = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EvaluatedStrategy_StrategyLeg {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      buySellIndicator: isSet(object.buySellIndicator)
        ? evaluatedStrategy_BuySellIndicatorFromJSON(object.buySellIndicator)
        : 0,
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : 0,
    };
  },

  toJSON(message: EvaluatedStrategy_StrategyLeg): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.buySellIndicator !== 0) {
      obj.buySellIndicator = evaluatedStrategy_BuySellIndicatorToJSON(message.buySellIndicator);
    }
    if (message.quantity !== 0) {
      obj.quantity = Math.round(message.quantity);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EvaluatedStrategy_StrategyLeg>, I>>(base?: I): EvaluatedStrategy_StrategyLeg {
    return EvaluatedStrategy_StrategyLeg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EvaluatedStrategy_StrategyLeg>, I>>(
    object: I,
  ): EvaluatedStrategy_StrategyLeg {
    const message = createBaseEvaluatedStrategy_StrategyLeg();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.buySellIndicator = object.buySellIndicator ?? 0;
    message.quantity = object.quantity ?? 0;
    return message;
  },
};

function createBaseStrategyTemplateLegProto(): StrategyTemplateLegProto {
  return {
    id: "",
    categoryCode: 0,
    expirySelection: undefined,
    transactionType: 0,
    lots: 0,
    optionType: undefined,
    strikeCriteria: undefined,
  };
}

export const StrategyTemplateLegProto = {
  encode(message: StrategyTemplateLegProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.categoryCode !== 0) {
      writer.uint32(24).int32(message.categoryCode);
    }
    if (message.expirySelection !== undefined) {
      StrategyTemplateLegProto_ExpirySelectionProto.encode(message.expirySelection, writer.uint32(34).fork()).ldelim();
    }
    if (message.transactionType !== 0) {
      writer.uint32(40).int32(message.transactionType);
    }
    if (message.lots !== 0) {
      writer.uint32(48).int32(message.lots);
    }
    if (message.optionType !== undefined) {
      writer.uint32(56).int32(message.optionType);
    }
    if (message.strikeCriteria !== undefined) {
      StrategyTemplateLegProto_StrikeCriteriaProto.encode(message.strikeCriteria, writer.uint32(66).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StrategyTemplateLegProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStrategyTemplateLegProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.categoryCode = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.expirySelection = StrategyTemplateLegProto_ExpirySelectionProto.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.transactionType = reader.int32() as any;
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.lots = reader.int32();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.optionType = reader.int32() as any;
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.strikeCriteria = StrategyTemplateLegProto_StrikeCriteriaProto.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StrategyTemplateLegProto {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      categoryCode: isSet(object.categoryCode) ? securityCategory_CategoryCodeFromJSON(object.categoryCode) : 0,
      expirySelection: isSet(object.expirySelection)
        ? StrategyTemplateLegProto_ExpirySelectionProto.fromJSON(object.expirySelection)
        : undefined,
      transactionType: isSet(object.transactionType) ? transactionTypeFromJSON(object.transactionType) : 0,
      lots: isSet(object.lots) ? globalThis.Number(object.lots) : 0,
      optionType: isSet(object.optionType) ? optionTypeFromJSON(object.optionType) : undefined,
      strikeCriteria: isSet(object.strikeCriteria)
        ? StrategyTemplateLegProto_StrikeCriteriaProto.fromJSON(object.strikeCriteria)
        : undefined,
    };
  },

  toJSON(message: StrategyTemplateLegProto): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.categoryCode !== 0) {
      obj.categoryCode = securityCategory_CategoryCodeToJSON(message.categoryCode);
    }
    if (message.expirySelection !== undefined) {
      obj.expirySelection = StrategyTemplateLegProto_ExpirySelectionProto.toJSON(message.expirySelection);
    }
    if (message.transactionType !== 0) {
      obj.transactionType = transactionTypeToJSON(message.transactionType);
    }
    if (message.lots !== 0) {
      obj.lots = Math.round(message.lots);
    }
    if (message.optionType !== undefined) {
      obj.optionType = optionTypeToJSON(message.optionType);
    }
    if (message.strikeCriteria !== undefined) {
      obj.strikeCriteria = StrategyTemplateLegProto_StrikeCriteriaProto.toJSON(message.strikeCriteria);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StrategyTemplateLegProto>, I>>(base?: I): StrategyTemplateLegProto {
    return StrategyTemplateLegProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StrategyTemplateLegProto>, I>>(object: I): StrategyTemplateLegProto {
    const message = createBaseStrategyTemplateLegProto();
    message.id = object.id ?? "";
    message.categoryCode = object.categoryCode ?? 0;
    message.expirySelection = (object.expirySelection !== undefined && object.expirySelection !== null)
      ? StrategyTemplateLegProto_ExpirySelectionProto.fromPartial(object.expirySelection)
      : undefined;
    message.transactionType = object.transactionType ?? 0;
    message.lots = object.lots ?? 0;
    message.optionType = object.optionType ?? undefined;
    message.strikeCriteria = (object.strikeCriteria !== undefined && object.strikeCriteria !== null)
      ? StrategyTemplateLegProto_StrikeCriteriaProto.fromPartial(object.strikeCriteria)
      : undefined;
    return message;
  },
};

function createBaseStrategyTemplateLegProto_ExpirySelectionProto(): StrategyTemplateLegProto_ExpirySelectionProto {
  return { expirySelectionType: 0, minimumDaysToExpiry: undefined, rolloverFlag: undefined };
}

export const StrategyTemplateLegProto_ExpirySelectionProto = {
  encode(message: StrategyTemplateLegProto_ExpirySelectionProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.expirySelectionType !== 0) {
      writer.uint32(8).int32(message.expirySelectionType);
    }
    if (message.minimumDaysToExpiry !== undefined) {
      writer.uint32(16).int32(message.minimumDaysToExpiry);
    }
    if (message.rolloverFlag !== undefined) {
      writer.uint32(24).bool(message.rolloverFlag);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StrategyTemplateLegProto_ExpirySelectionProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStrategyTemplateLegProto_ExpirySelectionProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.expirySelectionType = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.minimumDaysToExpiry = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.rolloverFlag = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StrategyTemplateLegProto_ExpirySelectionProto {
    return {
      expirySelectionType: isSet(object.expirySelectionType)
        ? strategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionTypeFromJSON(object.expirySelectionType)
        : 0,
      minimumDaysToExpiry: isSet(object.minimumDaysToExpiry)
        ? globalThis.Number(object.minimumDaysToExpiry)
        : undefined,
      rolloverFlag: isSet(object.rolloverFlag) ? globalThis.Boolean(object.rolloverFlag) : undefined,
    };
  },

  toJSON(message: StrategyTemplateLegProto_ExpirySelectionProto): unknown {
    const obj: any = {};
    if (message.expirySelectionType !== 0) {
      obj.expirySelectionType = strategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionTypeToJSON(
        message.expirySelectionType,
      );
    }
    if (message.minimumDaysToExpiry !== undefined) {
      obj.minimumDaysToExpiry = Math.round(message.minimumDaysToExpiry);
    }
    if (message.rolloverFlag !== undefined) {
      obj.rolloverFlag = message.rolloverFlag;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StrategyTemplateLegProto_ExpirySelectionProto>, I>>(
    base?: I,
  ): StrategyTemplateLegProto_ExpirySelectionProto {
    return StrategyTemplateLegProto_ExpirySelectionProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StrategyTemplateLegProto_ExpirySelectionProto>, I>>(
    object: I,
  ): StrategyTemplateLegProto_ExpirySelectionProto {
    const message = createBaseStrategyTemplateLegProto_ExpirySelectionProto();
    message.expirySelectionType = object.expirySelectionType ?? 0;
    message.minimumDaysToExpiry = object.minimumDaysToExpiry ?? undefined;
    message.rolloverFlag = object.rolloverFlag ?? undefined;
    return message;
  },
};

function createBaseStrategyTemplateLegProto_StrikeCriteriaProto(): StrategyTemplateLegProto_StrikeCriteriaProto {
  return { strikeType: 0, referenceType: 0, value: 0, parametersMap: {} };
}

export const StrategyTemplateLegProto_StrikeCriteriaProto = {
  encode(message: StrategyTemplateLegProto_StrikeCriteriaProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.strikeType !== 0) {
      writer.uint32(8).int32(message.strikeType);
    }
    if (message.referenceType !== 0) {
      writer.uint32(16).int32(message.referenceType);
    }
    if (message.value !== 0) {
      writer.uint32(29).float(message.value);
    }
    Object.entries(message.parametersMap).forEach(([key, value]) => {
      StrategyTemplateLegProto_StrikeCriteriaProto_ParametersMapEntry.encode(
        { key: key as any, value },
        writer.uint32(34).fork(),
      ).ldelim();
    });
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StrategyTemplateLegProto_StrikeCriteriaProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStrategyTemplateLegProto_StrikeCriteriaProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.strikeType = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.referenceType = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.value = reader.float();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          const entry4 = StrategyTemplateLegProto_StrikeCriteriaProto_ParametersMapEntry.decode(
            reader,
            reader.uint32(),
          );
          if (entry4.value !== undefined) {
            message.parametersMap[entry4.key] = entry4.value;
          }
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StrategyTemplateLegProto_StrikeCriteriaProto {
    return {
      strikeType: isSet(object.strikeType)
        ? strategyTemplateLegProto_StrikeCriteriaProto_StrikeTypeFromJSON(object.strikeType)
        : 0,
      referenceType: isSet(object.referenceType)
        ? strategyTemplateLegProto_StrikeCriteriaProto_ReferenceTypeFromJSON(object.referenceType)
        : 0,
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
      parametersMap: isObject(object.parametersMap)
        ? Object.entries(object.parametersMap).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: StrategyTemplateLegProto_StrikeCriteriaProto): unknown {
    const obj: any = {};
    if (message.strikeType !== 0) {
      obj.strikeType = strategyTemplateLegProto_StrikeCriteriaProto_StrikeTypeToJSON(message.strikeType);
    }
    if (message.referenceType !== 0) {
      obj.referenceType = strategyTemplateLegProto_StrikeCriteriaProto_ReferenceTypeToJSON(message.referenceType);
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    if (message.parametersMap) {
      const entries = Object.entries(message.parametersMap);
      if (entries.length > 0) {
        obj.parametersMap = {};
        entries.forEach(([k, v]) => {
          obj.parametersMap[k] = Math.round(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StrategyTemplateLegProto_StrikeCriteriaProto>, I>>(
    base?: I,
  ): StrategyTemplateLegProto_StrikeCriteriaProto {
    return StrategyTemplateLegProto_StrikeCriteriaProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StrategyTemplateLegProto_StrikeCriteriaProto>, I>>(
    object: I,
  ): StrategyTemplateLegProto_StrikeCriteriaProto {
    const message = createBaseStrategyTemplateLegProto_StrikeCriteriaProto();
    message.strikeType = object.strikeType ?? 0;
    message.referenceType = object.referenceType ?? 0;
    message.value = object.value ?? 0;
    message.parametersMap = Object.entries(object.parametersMap ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseStrategyTemplateLegProto_StrikeCriteriaProto_ParametersMapEntry(): StrategyTemplateLegProto_StrikeCriteriaProto_ParametersMapEntry {
  return { key: "", value: 0 };
}

export const StrategyTemplateLegProto_StrikeCriteriaProto_ParametersMapEntry = {
  encode(
    message: StrategyTemplateLegProto_StrikeCriteriaProto_ParametersMapEntry,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(16).int32(message.value);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): StrategyTemplateLegProto_StrikeCriteriaProto_ParametersMapEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStrategyTemplateLegProto_StrikeCriteriaProto_ParametersMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.value = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StrategyTemplateLegProto_StrikeCriteriaProto_ParametersMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: StrategyTemplateLegProto_StrikeCriteriaProto_ParametersMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = Math.round(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StrategyTemplateLegProto_StrikeCriteriaProto_ParametersMapEntry>, I>>(
    base?: I,
  ): StrategyTemplateLegProto_StrikeCriteriaProto_ParametersMapEntry {
    return StrategyTemplateLegProto_StrikeCriteriaProto_ParametersMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StrategyTemplateLegProto_StrikeCriteriaProto_ParametersMapEntry>, I>>(
    object: I,
  ): StrategyTemplateLegProto_StrikeCriteriaProto_ParametersMapEntry {
    const message = createBaseStrategyTemplateLegProto_StrikeCriteriaProto_ParametersMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseStrategyTemplateLegsProto(): StrategyTemplateLegsProto {
  return { strategyTemplateLegs: [] };
}

export const StrategyTemplateLegsProto = {
  encode(message: StrategyTemplateLegsProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.strategyTemplateLegs) {
      StrategyTemplateLegProto.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StrategyTemplateLegsProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStrategyTemplateLegsProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.strategyTemplateLegs.push(StrategyTemplateLegProto.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StrategyTemplateLegsProto {
    return {
      strategyTemplateLegs: globalThis.Array.isArray(object?.strategyTemplateLegs)
        ? object.strategyTemplateLegs.map((e: any) => StrategyTemplateLegProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: StrategyTemplateLegsProto): unknown {
    const obj: any = {};
    if (message.strategyTemplateLegs?.length) {
      obj.strategyTemplateLegs = message.strategyTemplateLegs.map((e) => StrategyTemplateLegProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StrategyTemplateLegsProto>, I>>(base?: I): StrategyTemplateLegsProto {
    return StrategyTemplateLegsProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StrategyTemplateLegsProto>, I>>(object: I): StrategyTemplateLegsProto {
    const message = createBaseStrategyTemplateLegsProto();
    message.strategyTemplateLegs = object.strategyTemplateLegs?.map((e) => StrategyTemplateLegProto.fromPartial(e)) ||
      [];
    return message;
  },
};

function createBaseOptionPosition(): OptionPosition {
  return { optionType: 0, transactionType: 0, strikePrice: 0, expiry: 0, lots: 0 };
}

export const OptionPosition = {
  encode(message: OptionPosition, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.optionType !== 0) {
      writer.uint32(8).int32(message.optionType);
    }
    if (message.transactionType !== 0) {
      writer.uint32(16).int32(message.transactionType);
    }
    if (message.strikePrice !== 0) {
      writer.uint32(24).int32(message.strikePrice);
    }
    if (message.expiry !== 0) {
      writer.uint32(32).int64(message.expiry);
    }
    if (message.lots !== 0) {
      writer.uint32(40).int32(message.lots);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OptionPosition {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOptionPosition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.optionType = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.transactionType = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.strikePrice = reader.int32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.expiry = longToNumber(reader.int64() as Long);
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.lots = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OptionPosition {
    return {
      optionType: isSet(object.optionType) ? optionTypeFromJSON(object.optionType) : 0,
      transactionType: isSet(object.transactionType) ? transactionTypeFromJSON(object.transactionType) : 0,
      strikePrice: isSet(object.strikePrice) ? globalThis.Number(object.strikePrice) : 0,
      expiry: isSet(object.expiry) ? globalThis.Number(object.expiry) : 0,
      lots: isSet(object.lots) ? globalThis.Number(object.lots) : 0,
    };
  },

  toJSON(message: OptionPosition): unknown {
    const obj: any = {};
    if (message.optionType !== 0) {
      obj.optionType = optionTypeToJSON(message.optionType);
    }
    if (message.transactionType !== 0) {
      obj.transactionType = transactionTypeToJSON(message.transactionType);
    }
    if (message.strikePrice !== 0) {
      obj.strikePrice = Math.round(message.strikePrice);
    }
    if (message.expiry !== 0) {
      obj.expiry = Math.round(message.expiry);
    }
    if (message.lots !== 0) {
      obj.lots = Math.round(message.lots);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OptionPosition>, I>>(base?: I): OptionPosition {
    return OptionPosition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OptionPosition>, I>>(object: I): OptionPosition {
    const message = createBaseOptionPosition();
    message.optionType = object.optionType ?? 0;
    message.transactionType = object.transactionType ?? 0;
    message.strikePrice = object.strikePrice ?? 0;
    message.expiry = object.expiry ?? 0;
    message.lots = object.lots ?? 0;
    return message;
  },
};

function createBaseOptionPositionRequest(): OptionPositionRequest {
  return { optionPosition: [] };
}

export const OptionPositionRequest = {
  encode(message: OptionPositionRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.optionPosition) {
      OptionPosition.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OptionPositionRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOptionPositionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.optionPosition.push(OptionPosition.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OptionPositionRequest {
    return {
      optionPosition: globalThis.Array.isArray(object?.optionPosition)
        ? object.optionPosition.map((e: any) => OptionPosition.fromJSON(e))
        : [],
    };
  },

  toJSON(message: OptionPositionRequest): unknown {
    const obj: any = {};
    if (message.optionPosition?.length) {
      obj.optionPosition = message.optionPosition.map((e) => OptionPosition.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OptionPositionRequest>, I>>(base?: I): OptionPositionRequest {
    return OptionPositionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OptionPositionRequest>, I>>(object: I): OptionPositionRequest {
    const message = createBaseOptionPositionRequest();
    message.optionPosition = object.optionPosition?.map((e) => OptionPosition.fromPartial(e)) || [];
    return message;
  },
};

function createBaseOptionPositionResponse(): OptionPositionResponse {
  return { strategyName: "" };
}

export const OptionPositionResponse = {
  encode(message: OptionPositionResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.strategyName !== "") {
      writer.uint32(10).string(message.strategyName);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OptionPositionResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOptionPositionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.strategyName = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OptionPositionResponse {
    return { strategyName: isSet(object.strategyName) ? globalThis.String(object.strategyName) : "" };
  },

  toJSON(message: OptionPositionResponse): unknown {
    const obj: any = {};
    if (message.strategyName !== "") {
      obj.strategyName = message.strategyName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OptionPositionResponse>, I>>(base?: I): OptionPositionResponse {
    return OptionPositionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OptionPositionResponse>, I>>(object: I): OptionPositionResponse {
    const message = createBaseOptionPositionResponse();
    message.strategyName = object.strategyName ?? "";
    return message;
  },
};

export interface StrategyService {
  GetStrategyTemplates(request: Empty): Promise<StrategyTemplatesProto>;
  CreateStrategyTemplate(request: StrategyTemplateProto): Promise<StrategyTemplateProto>;
  ModifyStrategyTemplate(request: StrategyTemplateProto): Promise<StrategyTemplateProto>;
  DisableStrategyTemplate(request: StrategyTemplateProto): Promise<Empty>;
  GetStrategyTemplateName(request: OptionPositionRequest): Promise<OptionPositionResponse>;
}

export const StrategyServiceServiceName = "com.tick2trade.api.strategy.StrategyService";
export class StrategyServiceClientImpl implements StrategyService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || StrategyServiceServiceName;
    this.rpc = rpc;
    this.GetStrategyTemplates = this.GetStrategyTemplates.bind(this);
    this.CreateStrategyTemplate = this.CreateStrategyTemplate.bind(this);
    this.ModifyStrategyTemplate = this.ModifyStrategyTemplate.bind(this);
    this.DisableStrategyTemplate = this.DisableStrategyTemplate.bind(this);
    this.GetStrategyTemplateName = this.GetStrategyTemplateName.bind(this);
  }
  GetStrategyTemplates(request: Empty): Promise<StrategyTemplatesProto> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetStrategyTemplates", data);
    return promise.then((data) => StrategyTemplatesProto.decode(_m0.Reader.create(data)));
  }

  CreateStrategyTemplate(request: StrategyTemplateProto): Promise<StrategyTemplateProto> {
    const data = StrategyTemplateProto.encode(request).finish();
    const promise = this.rpc.request(this.service, "CreateStrategyTemplate", data);
    return promise.then((data) => StrategyTemplateProto.decode(_m0.Reader.create(data)));
  }

  ModifyStrategyTemplate(request: StrategyTemplateProto): Promise<StrategyTemplateProto> {
    const data = StrategyTemplateProto.encode(request).finish();
    const promise = this.rpc.request(this.service, "ModifyStrategyTemplate", data);
    return promise.then((data) => StrategyTemplateProto.decode(_m0.Reader.create(data)));
  }

  DisableStrategyTemplate(request: StrategyTemplateProto): Promise<Empty> {
    const data = StrategyTemplateProto.encode(request).finish();
    const promise = this.rpc.request(this.service, "DisableStrategyTemplate", data);
    return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
  }

  GetStrategyTemplateName(request: OptionPositionRequest): Promise<OptionPositionResponse> {
    const data = OptionPositionRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetStrategyTemplateName", data);
    return promise.then((data) => OptionPositionResponse.decode(_m0.Reader.create(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
